export default {
	path: '/accident-statistic',
	redirect: '/accident-statistic',
	component: () => import('@/views/layout/Default'),
	children: [
		{
			path: '/',
			name: 'accidentStatisticHome',
			component: () => import('@/views/biz/AccidentStatistic'),
		},
	],
};
